<template>
  <b-modal
    ok-title="Enviar"
    id="modal-1"
    modal
    :title="$ml.get('activeDoubleCampaign')"
  >
    <div class="d-flex align-items-center mb-4">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="bounties"
        />
        <label class="custom-control-label" v-text="$ml.get('doubleBounties')"
          >Bounties</label
        >
      </div>
      <div class="custom-control custom-checkbox ml-4">
        <input type="checkbox" class="custom-control-input" v-model="score" />
        <label class="custom-control-label" v-text="$ml.get('doubleScore')"
          >Pontuação</label
        >
      </div>
    </div>
    <div class="d-flex">
      <div class="col-12 pr-2 input-group">
        <b-form-datepicker
          class="datepicker m-0 p-0"
          label-help=""
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          :locale="$ml.get('ln')"
          today-button
          reset-button
          close-button
          :label-today-button="$ml.get('today')"
          :label-reset-button="$ml.get('reset')"
          :label-close-button="$ml.get('exit')"
          :min="minDateInitialCampaign"
          v-model="initialDate"
          :placeholder="$ml.get('start')"
        >
        </b-form-datepicker>
      </div>
      <div class="col-12 input-group">
        <b-form-datepicker
          class="datepicker m-0 p-0"
          label-help=""
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          :locale="$ml.get('ln')"
          today-button
          reset-button
          close-button
          :label-today-button="$ml.get('today')"
          :label-reset-button="$ml.get('reset')"
          :label-close-button="$ml.get('exit')"
          :min="initialDate"
          :max="maxDate"
          v-model="finalDate"
          :disabled="initialDate == null"
          :placeholder="$ml.get('end')"
        >
        </b-form-datepicker>
      </div>
    </div>
    <div class="card card-body mt-4 p-0 d-flex w-100">
      <table class="mb-2">
        <thead>
          <tr>
            <th class="col-10" v-text="$ml.get('severity')">Severidade</th>
            <th class="col-7" v-text="$ml.get('currentValue')">Valor Atual</th>
            <th class="col-7" v-text="$ml.get('finalValue')">Valor Final</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="col-10 row d-flex align-content-center">
              <Impact impact="impact-low" class="mt-1" />
              <strong class="mx-2" v-text="$ml.get('low')">Baixo</strong>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_low')"
                  class="form-control mask-real"
                  v-model="bounty_low"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  readonly
                  class="form-control mask-real"
                  :value="bounties ? doubleBountyLow : bounty_low"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="col-10 row d-flex align-content-center">
              <Impact impact="impact-medium" class="mt-1" />
              <strong class="mx-2" v-text="$ml.get('medium')">Médio</strong>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_medium')"
                  class="form-control mask-real"
                  v-model="bounty_medium"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_medium')"
                  class="form-control mask-real"
                  readonly
                  :value="bounties ? doubleBountyMedium : bounty_medium"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="col-10 row d-flex align-content-center">
              <Impact impact="impact-high" class="mt-1" />
              <strong class="mx-2" v-text="$ml.get('high')">Alto</strong>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_high')"
                  class="form-control mask-real"
                  v-model="bounty_high"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_high')"
                  class="form-control mask-real"
                  readonly
                  :value="bounties ? doubleBountyHigh : bounty_high"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="col-10 row d-flex align-content-center">
              <Impact impact="impact-critical" class="mt-1" />
              <strong class="mx-2" v-text="$ml.get('critical')">Crítico</strong>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_critical')"
                  class="form-control mask-real"
                  v-model="bounty_critical"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
            <td class="text-muted col-7">
              <div class="col-24">
                <money
                  @input.native="mathAbsMoney('bounty_critical')"
                  class="form-control mask-real"
                  readonly
                  :value="bounties ? doubleBountyCritical : bounty_critical"
                  :placeholder="placeholderMoney"
                  maxLength="13"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="custom-control custom-checkbox mt-3">
      <input
        type="checkbox"
        class="custom-control-input"
        v-model="confirmDoubleReward"
        style="height: 15px; width: 15px"
      />
      <label
        class="custom-control-label"
        v-text="$ml.get('doubleCheckCampaign')"
        >Estou ciente das alterações do valor atual das recompensas.</label
      >
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        :disabled="!confirmDoubleReward"
        style="background: #730ba9"
        size="sm"
        @click="ok(), createDoubleCampaing()"
      >
        {{ $ml.get("btnRegister") }}
      </b-button>
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="cancel()"
      >
        {{ $ml.get("btnCancel") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import moment from "moment";
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";
export default {
  name: "ModalDoubleReward",
  props: {
    bounty_low: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_medium: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_high: {
      type: Number,
      required: false,
      default: 0,
    },
    bounty_critical: {
      type: Number,
      required: false,
      default: 0,
    },
    changeProgram: {
      type: Function,
      requerid: false,
      default: () => {},
    },
  },

  data() {
    return {
      id: "",
      double_reward: 2,
      bounties: false,
      score: false,
      initialDate: null,
      finalDate: null,
      confirmDoubleReward: false,
      maxDate: null,
      currency:"",
    };
  },

  created() {
    this.id = this.$route.fullPath.split("?")[1];
  },

  watch: {
    // Define a data máxima após a data inicial ser selecionada
    initialDate(newValue) {
      const maxDate = new Date(newValue);
      maxDate.setDate(maxDate.getDate() + 15);
      this.maxDate = maxDate.toISOString().slice(0, 10);
    },
  },

  computed: {
    doubleBountyLow() {
      return this.bounty_low * this.double_reward;
    },
    doubleBountyMedium() {
      return this.bounty_medium * this.double_reward;
    },
    doubleBountyHigh() {
      return this.bounty_high * this.double_reward;
    },
    doubleBountyCritical() {
      return this.bounty_critical * this.double_reward;
    },
    minDateInitialCampaign() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYY-MM-DD");
      return today;
    },
    placeholderMoney(){
        return this.currency === 'BRL' ? 'R$ 0,00' : '$ 0,00'
    }
  },
  mounted(){
    this.currency = this.$store.getters['getUser'].currency;
  },
  methods: {
    async createDoubleCampaing() {
      const self = this;

      if (this.initialDate == null || this.finalDate == null) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("invalidDateMessage"),
        });
        return;
      }

      if (this.bounties == false && this.score == false) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("warningBoutiesOrScore"),
        });
        return;
      }

      try {
        await ProgramService.postProgramCampaign(this.id, {
          offers_double_bounty: this.bounties == true ? "yes" : "no",
          offers_double_score: this.score == true ? "yes" : "no",
          campaign_initial_date: moment(this.initialDate).format(
            "YYYY-MM-DDTHH:mm:ss.SSS",
          ),
          campaign_final_date: moment(this.finalDate).format(
            "YYYY-MM-DDTHH:mm:ss.SSS",
          ),
        });

        Swal.fire({
          icon: "success",
          title: self.$ml.get("successfullyCreatedCampaign"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
        });

        this.changeProgram(this.$route.fullPath.split("?")[1]);
      } catch (error) {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("registeredProgramWarning"),
        });
      }
    },
  },
};
</script>
